import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Icon from '../components/common/Icon';
import Breadcrumbs from '../components/common/Breadcrumbs';
import SectionHeader from '../components/common/SectionHeader';
import NewsCard from '../components/common/NewsCard';
import EventCard from '../components/common/EventCard';
import Toolbar from '../components/common/Toolbar';
import SearchBar from '../components/common/SearchBar';
import FilterSelect from '../components/common/FilterSelect';

const delegaData = {
  organizzazione: {
    title: 'Organizzazione',
    heroImage: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1600&auto=format&fit=crop',
    head: { 
      name: 'Alessandro Ferretti', 
      role: 'Responsabile Nazionale Organizzazione', 
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=400&auto=format&fit=crop',
      bio: "Coordinatore instancabile della rete territoriale. Alessandro crede nella forza della partecipazione capillare e nel valore di ogni singolo circolo."
    },
    description: "Gestiamo la struttura del movimento, garantendo che ogni circolo e ogni federazione abbia gli strumenti per agire sul territorio.",
    color: 'var(--color-primary)',
    icon: 'Settings',
    tasks: [
      { title: 'Tesseramento', text: 'Gestione anagrafe e nuovi iscritti.', icon: 'UserPlus' },
      { title: 'Rete Territoriale', text: 'Supporto a circoli e federazioni.', icon: 'Map' },
      { title: 'Logistica', text: 'Organizzazione eventi nazionali.', icon: 'Package' },
      { title: 'Regolamenti', text: 'Garanzia delle procedure democratiche.', icon: 'FileText' }
    ],
    news: [
      { id: 1, title: 'Roadmap Organizzativa 2026', date: '12 Apr 2026', category: 'Organizzazione', excerpt: 'Le tappe fondamentali per il rafforzamento della nostra rete territoriale.', image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=600' }
    ],
    events: [
      { id: 101, title: 'Webinar: Gestione Anagrafe Digitale', day: '25', month: 'Mag', location: 'Online', time: '18:00', badge: 'Formazione', image: 'https://images.unsplash.com/photo-1524178232363-1fb28f74b55a?q=80&w=600' }
    ],
    documents: [
      { title: 'Guida al Tesseramento 2026', type: 'Manuale', date: '10 Gen 2026', badge: 'PDF', size: '2.1 MB' }
    ]
  },
  comunicazione: {
    title: 'Comunicazione',
    heroImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1600&auto=format&fit=crop',
    head: { 
      name: 'Sofia Ricciardi', 
      role: 'Responsabile Nazionale Comunicazione', 
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=400&auto=format&fit=crop',
      bio: "Esperta di media digitali e narrazione politica. Sofia coordina l'immagine dei GD per parlare a una nuova generazione di cittadini."
    },
    description: "Raccontiamo le nostre battaglie, diamo voce ai territori e costruiamo l'identità visiva e politica del nostro movimento.",
    color: '#f59e0b',
    icon: 'Megaphone',
    tasks: [
      { title: 'Social Media', text: 'Gestione canali nazionali.', icon: 'Share2' },
      { title: 'Press Office', text: 'Rapporti con i media e comunicati.', icon: 'Newspaper' },
      { title: 'Grafica', text: 'Identità visiva e materiali.', icon: 'Layout' },
      { title: 'Content', text: 'Produzione video e podcast.', icon: 'Video' }
    ],
    news: [
      { id: 2, title: 'Nuovo Kit Grafico per i Circoli', date: '05 Apr 2026', category: 'Risorse', excerpt: 'Disponibili i nuovi template per la comunicazione locale.', image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=600' }
    ],
    events: [
      { id: 102, title: 'Workshop: Social Media Strategy', day: '10', month: 'Giu', location: 'Roma', time: '15:00', badge: 'Workshop', image: 'https://images.unsplash.com/photo-1551818255-e6e10975bc17?q=80&w=600' }
    ],
    documents: [
      { title: 'Brand Manual GD 2026', type: 'Guida', date: '01 Mar 2026', badge: 'PDF', size: '5.4 MB' }
    ]
  }
};

const DelegaPage = () => {
  const { id } = useParams();
  const data = delegaData[id] || delegaData.organizzazione;

  const breadcrumbs = [
    { label: 'Home', path: '/' },
    { label: 'Segreteria', path: '/segreteria' },
    { label: data.title }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <Layout>
      {/* EPIC HERO SECTION */}
      <section className="hero--epic">
        <div className="hero__bg">
          <div className="hero__image" style={{ backgroundImage: `url(${data.heroImage})` }}></div>
          <div className="hero__overlay" style={{ background: `linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(9,9,11,0.95) 100%)` }}></div>
        </div>
        
        <div className="hero__content-epic container" style={{ color: '#fff' }}>
          <div className="reveal" style={{ marginBottom: 'var(--space-8)' }}>
            <Breadcrumbs items={breadcrumbs} style={{ color: 'rgba(255,255,255,0.7)' }} />
          </div>
          
          <div className="reveal mb-6">
            <span className="badge" style={{ background: data.color, color: '#fff', border: 'none', padding: 'var(--space-2) var(--space-4)', fontSize: 'var(--text-xs)' }}>
              Delega Nazionale
            </span>
          </div>
          
          <h1 className="hero__title-epic text-reveal-trigger" style={{ color: '#fff', fontSize: 'clamp(3rem, 8vw, 6rem)' }}>
            <span className="line text-reveal"><span className="word text-reveal__inner">{data.title}</span></span>
          </h1>
          
          <p className="hero__subtitle-epic reveal" style={{ color: 'rgba(255,255,255,0.9)', maxWidth: '700px', fontSize: 'var(--text-body-lg)' }}>
            {data.description}
          </p>
        </div>
      </section>

      {/* RESPONSIBLE & TASKS SECTION */}
      <section className="section" style={{ marginTop: '-120px', position: 'relative', zIndex: 10, paddingTop: 0 }}>
        <div className="container">
          <div className="reveal reveal--scale mb-12">
            <div style={{ 
              background: 'rgba(255, 255, 255, 0.8)', 
              backdropFilter: 'blur(20px)',
              padding: 'var(--space-8)', 
              borderRadius: 'var(--radius-3xl)',
              boxShadow: '0 30px 60px rgba(0,0,0,0.12)',
              border: '1px solid rgba(255,255,255,0.3)',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 'var(--space-10)'
            }}>
              <div style={{ width: '180px', height: '180px', borderRadius: 'var(--radius-2xl)', overflow: 'hidden', boxShadow: 'var(--shadow-lg)' }}>
                <img src={data.head.image} alt={data.head.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div style={{ flex: 1, minWidth: '300px' }}>
                <span className="text-overline mb-2 block" style={{ color: data.color }}>Responsabile di Delega</span>
                <h2 className="h2 mb-4">{data.head.name}</h2>
                <p className="text-body text-secondary mb-6 italic" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  "{data.head.bio}"
                </p>
                <div className="flex gap-4">
                  <Link to="#" className="btn btn--primary">Contatta {data.head.name.split(' ')[0]}</Link>
                  <div className="flex gap-3 ml-4 items-center">
                    <Link to="#" className="text-secondary hover:text-primary transition-colors"><Icon name="Twitter" size={20} /></Link>
                    <Link to="#" className="text-secondary hover:text-primary transition-colors"><Icon name="Linkedin" size={20} /></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* MISSION & TASKS INTEGRATED */}
          <div style={{ background: 'var(--color-bg-subtle)', padding: 'var(--space-10)', borderRadius: 'var(--radius-3xl)', border: '1px solid var(--color-border-subtle)' }} className="reveal reveal--scale">
            <SectionHeader overline="Deleghe e Compiti" title="Aree di competenza" className="mb-10" />
            <div className="grid grid-4 gap-6">
              {data.tasks.map((task, i) => (
                <div key={i} className="flex flex-col gap-4 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow reveal stagger-2">
                  <div style={{ color: data.color, background: `${data.color}15`, width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Icon name={task.icon} size={24} />
                  </div>
                  <div>
                    <h4 className="h5 mb-2">{task.title}</h4>
                    <p className="text-xs text-secondary">{task.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NEWS SECTION */}
      <section className="section bg-subtle">
        <div className="container">
          <SectionHeader overline="Editoriale" title="Ultime dall'area" className="mb-8" />
          
          <Toolbar
            className="mb-10 reveal"
            left={<SearchBar placeholder="Cerca tra i contenuti..." ariaLabel="Cerca notizie delega" />}
            right={<>
              <FilterSelect label="Categoria" options={['Tutte', 'Attualità', 'Comunicati']} />
            </>}
          />

          <div className="grid grid-3 gap-8">
            {data.news.map((n, i) => (
              <NewsCard 
                key={n.id} 
                news={n} 
                title={n.title}
                excerpt={n.excerpt}
                badge={n.category}
                meta={[n.date]}
                image={n.image}
                className={`reveal stagger-${i + 1}`} 
              />
            ))}
          </div>
        </div>
      </section>

      {/* EVENTS SECTION */}
      <section className="section bg-white border-bottom">
        <div className="container">
          <SectionHeader overline="Agenda" title="Appuntamenti Area" className="mb-8" />
          
          <Toolbar className="mb-8 reveal"
            left={<FilterSelect label="Tipo" options={['Tutti', 'Webinar', 'Incontro']} />}
            right={<button className="btn btn--outline btn--sm">📅 Calendario</button>}
          />

          <div className="grid grid-3 gap-8">
            {data.events.map((e, i) => (
              <EventCard 
                key={e.id} 
                {...e}
                className={`reveal stagger-${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* DOCUMENTS SECTION */}
      <section className="section bg-subtle">
        <div className="container">
          <SectionHeader overline="Risorse" title="Documenti e Materiali" className="mb-8" />
          
          <Toolbar className="mb-8 reveal"
            left={<SearchBar placeholder="Cerca risorsa..." ariaLabel="Cerca" />}
          />

          <div className="flex flex-col gap-4 reveal">
            {data.documents.map((d, i) => (
              <a 
                href="#" 
                className={`card flex justify-between items-center hover:border-primary transition-all stagger-${i + 1}`} 
                style={{ padding: 'var(--space-6)', background: '#fff', border: '1px solid var(--color-border-subtle)', borderRadius: 'var(--radius-xl)' }} 
                key={d.title}
              >
                <div style={{ flex: 1 }}>
                  <span className="badge badge--subtle mb-2" style={{ color: data.color, background: `${data.color}10` }}>{d.type}</span>
                  <h4 className="h5 mb-1">{d.title}</h4>
                  <span className="text-xs text-secondary uppercase tracking-wider">{d.date} • {d.size}</span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="badge badge--primary" style={{ background: data.color }}>{d.badge}</span>
                  <div className="btn btn--icon btn--sm btn--outline"><Icon name="Download" size={16} /></div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

    </Layout>
  );
};

export default DelegaPage;
